import { deviceApi } from "../../api/deviceApi.js"

import { deviceListSignal, deviceListLoadedSignal, deviceListErrorSignal } from '../signals/deviceSignals'

export async function fetchDeviceList(businessEntityId, filters, config, accessToken) {
    deviceListLoadedSignal.value = false
    deviceListSignal.value = []
    return await deviceApi.fetchDeviceList(businessEntityId, filters, config, accessToken).then(
        (result) => {
            deviceListSignal.value = result
            deviceListLoadedSignal.value = true
            return result
        }
    ).catch(
        (err) => {
            deviceListErrorSignal.value = err.message
        }
    )
}

export const exportDeviceList = async (businessEntityId, config, accessToken) => {
    return await deviceApi.exportDeviceList(businessEntityId, config, accessToken)
}